import React, { createContext, useState } from "react";
import { FormProvider } from "react-hook-form";
import { useFundActionPlan } from "../hooks/useFundActionPlan";
import { Grid } from "@mui/material";
import { DefaultArrayEmpty, I18n } from "utilities/utilities";
import DateRangeFund from "../components/DateRange";
import { BtnAdd, BtnDelete } from "components/Button/ButtonAll";
import { SelectItem } from "components/Input/Select/SelectItem";

export default function FudActionPlanFormBoardMeeting(props) {
    const {
        form,
        arrOptionCommittee,
        nYear,
        onAddBoardMeeting,
        onDeleteBoardMeeting,
        arrBoardMeeting,
        trigger
    } = props;

    return (
        <FormProvider {...form}>
            <Grid container spacing={2}>
                {/* Board Meeting */}
                {DefaultArrayEmpty(arrBoardMeeting).map((m, i) => (
                    <Grid item container spacing={2} key={"key_board_meeting_" + m.nID}>
                        <Grid item xs={12} md={5}>
                            <SelectItem
                                name={`sGroupMeeting_${m.nID}`}
                                label={I18n.SetText("FundPlan.GroupMeeting")}
                                placeholder={`${I18n.SetText("FundPlan.Choose")}${I18n.SetText("FundPlan.GroupMeeting")}`}
                                required
                                options={DefaultArrayEmpty(arrOptionCommittee)}
                            />
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <DateRangeFund
                                NameStart={`sStartMonthMeeting_${m.nID}`}
                                NameEnd={`sEndMonthMeeting_${m.nID}`}
                                LabelStart={I18n.SetText("FundPlan.StartMonth")}
                                LabelEnd={I18n.SetText("FundPlan.EndMonth")}
                                IsMonthPicker
                                required
                                isDisableYear
                                nYearMapper={nYear}
                                nTrigger={trigger}
                            />
                        </Grid>
                        <Grid item xs={6} md={2}>
                            <Grid container spacing={2}>
                                {arrBoardMeeting.length === (i + 1) &&
                                    <Grid item>
                                        <BtnAdd
                                            sColor="#00B393"
                                            sColorHover="#009278"
                                            id="AddBoard"
                                            txt={I18n.SetText("FundPlan.AddBoard")}
                                            IsCircleWithOutText
                                            onClick={form.handleSubmit(onAddBoardMeeting, (err) => {
                                                document.getElementById(Object.keys(err)[0])?.focus();
                                            })}
                                        />
                                    </Grid>
                                }
                                {arrBoardMeeting.length > 1 &&
                                    <Grid item>
                                        <BtnDelete
                                            sColorHover="#d30d1e"
                                            id="DeleteBoard"
                                            IsCircleWithOutText
                                            onClick={() => onDeleteBoardMeeting(m.nID)}
                                        />
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                ))}
            </Grid>
        </FormProvider>
    )
}